export default __webpack_public_path__ + "images/ba904544b7d85503ff44c2d8e7d36939-parents_association.webp";